// src/pages/ServiceExpenseLedger/ServiceExpenseLedgerSlice.js
import { createSlice } from "@reduxjs/toolkit";
import {
  fetchServiceExpenseLedger,
  fetchServiceExpenseAccountsBySearch,
} from "./ServiceExpenseLedgerThunk";

const initialState = {
  list: [],
  loading: false,
  serviceExpenseAccounts: [],
  serviceExpenseAccountLoading: false,
  filters: {
    accId: null,
    fromDate: null,
    toDate: null,
  },
};

const serviceExpenseLedgerSlice = createSlice({
  name: "serviceExpenseLedger",
  initialState,
  reducers: {
    setFilters: (state, action) => {
      state.filters = { ...state.filters, ...action.payload };
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchServiceExpenseLedger.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchServiceExpenseLedger.fulfilled, (state, action) => {
        state.loading = false;
        state.list = action.payload;
      })
      .addCase(fetchServiceExpenseLedger.rejected, (state) => {
        state.loading = false;
      })
      .addCase(fetchServiceExpenseAccountsBySearch.pending, (state) => {
        state.serviceExpenseAccountLoading = true;
      })
      .addCase(
        fetchServiceExpenseAccountsBySearch.fulfilled,
        (state, action) => {
          state.serviceExpenseAccountLoading = false;
          state.serviceExpenseAccounts = action.payload;
        }
      )
      .addCase(fetchServiceExpenseAccountsBySearch.rejected, (state) => {
        state.serviceExpenseAccountLoading = false;
        state.serviceExpenseAccounts = [];
      });
  },
});

export const { setFilters } = serviceExpenseLedgerSlice.actions;
export default serviceExpenseLedgerSlice.reducer;
